<template>
  <div>
    <common-dialog
      ref="dialog"
      width="300px"
      show-save-button
      edit-title
      title="修改卡号"
      id-key="StudentId"
      :data="data"
      form-label-width="55px"
      :form-rules="rules"
      :save-func="api.changeCardNumber"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="姓名">
              {{data.FullName}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="旧卡号">
              {{data.OldCardNumber}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="新卡号" prop="NewCardNumber">
              <el-input v-model="data.NewCardNumber" maxlength="10" oninput="value=value.replace(/[^\d]/g,'')" clearable placeholder="请填写新卡号（10位数）"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/st/student").default,
      data: {
        StudentId: 0,
        FullName: "",
        OldCardNumber: "",
        NewCardNumber: "",
      },
      isMB: this.$store.state.isMB,
      rules: {
        // NewCardNumber: [{ required: true, message: "请填写新卡号" }],
      },
    };
  },
  methods: {
    onCreateOpened() {
      
    },
    onEditOpened(data) {
      this.data.OldCardNumber = data.CardNumber;
    },
    onBeforeSave(data) {
      
    },
    onClosed() {
      this.data.NewCardNumber = "";
    },
  },
};
</script>
<style lang="scss">
</style>